import type { IconData } from '@stacksjs/iconify-core'

export const cl1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGPJQi7cGA\"><path fill-opacity=\".7\" d=\"M0 0h708.7v708.7H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGPJQi7cGA)\" transform=\"scale(.722)\"><path fill=\"#fff\" d=\"M354.3 0H1063v354.3H354.3z\"/><path fill=\"#0039a6\" d=\"M0 0h354.3v354.3H0z\"/><path fill=\"#fff\" d=\"m232.3 265.3l-55-41.1l-54.5 41.5l20.3-67.5l-54.5-41.7l67.4-.6l21-67.3l21.3 67.2h67.5L211.4 198z\"/><path fill=\"#d52b1e\" d=\"M0 354.3h1063v354.4H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cl1x1
